import { access } from '@driftt/traffic-control'

export const {
 hasScopes, hasAnyScope, hasGates, hasAccess, isAdmin, isAgent, isUser
} = access